import React, { useState } from 'react';

// Report Configuration Component with theme support
export const ReportConfiguration = ({ onGenerate, loading, isDarkMode }) => {
  const [config, setConfig] = useState({
    groupBySession: true,
    includeFields: {
      session_id: true,
      tag: true,
      department: true,
      position: true,
      company_time: true,
      dimension: true,
      question: true,
      response: true
    }
  });

  const fieldLabels = {
    session_id: 'ID da Sessão',
    tag: 'Cliente/Tag',
    department: 'Departamento',
    position: 'Cargo',
    company_time: 'Tempo na Empresa',
    dimension: 'Dimensão',
    question: 'Pergunta',
    response: 'Resposta'
  };

  const handleFieldToggle = (field) => {
    setConfig(prev => ({
      ...prev,
      includeFields: {
        ...prev.includeFields,
        [field]: !prev.includeFields[field]
      }
    }));
  };

  return (
    <div className={`p-6 rounded-xl border mb-6 ${
      isDarkMode 
        ? 'bg-gray-700/50 border-gray-600' 
        : 'bg-slate-50 border-slate-200'
    }`}>
      <h4 className={`font-semibold mb-4 ${
        isDarkMode ? 'text-white' : 'text-slate-800'
      }`}>⚙️ Configurações do Relatório</h4>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <h5 className={`font-medium mb-3 ${
            isDarkMode ? 'text-gray-200' : 'text-slate-700'
          }`}>Formato dos Dados</h5>
          <label className="flex items-center mb-2 cursor-pointer">
            <input
              type="radio"
              checked={config.groupBySession}
              onChange={() => setConfig(prev => ({...prev, groupBySession: true}))}
              className="mr-2 text-demoraes-green"
            />
            <span className={`text-sm ${
              isDarkMode ? 'text-gray-300' : 'text-slate-600'
            }`}>Agrupar por sessão (recomendado)</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              checked={!config.groupBySession}
              onChange={() => setConfig(prev => ({...prev, groupBySession: false}))}
              className="mr-2 text-demoraes-green"
            />
            <span className={`text-sm ${
              isDarkMode ? 'text-gray-300' : 'text-slate-600'
            }`}>Respostas individuais</span>
          </label>
        </div>
        
        <div>
          <h5 className={`font-medium mb-3 ${
            isDarkMode ? 'text-gray-200' : 'text-slate-700'
          }`}>Campos a Incluir</h5>
          <div className="grid grid-cols-2 gap-2">
            {Object.entries(fieldLabels).map(([field, label]) => (
              <label key={field} className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={config.includeFields[field]}
                  onChange={() => handleFieldToggle(field)}
                  className="mr-2 text-demoraes-green"
                />
                <span className={`text-sm ${
                  isDarkMode ? 'text-gray-300' : 'text-slate-600'
                }`}>{label}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
      
      <button
        onClick={() => onGenerate(config)}
        disabled={loading}
        className="mt-4 bg-demoraes-green hover:bg-demoraes-green/90 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-200 disabled:opacity-50 hover:scale-105 active:scale-95"
      >
        {loading ? (
          <div className="flex items-center">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            Gerando...
          </div>
        ) : (
          '📊 Gerar Relatório Excel'
        )}
      </button>
    </div>
  );
};
